import { Link } from "react-router-dom"
import Img from "./Img"
import mlw from "../../assets/mlw.webp"

export default function Logo({ className = "" }) {

  return (

    <Link to="/" className="flex items-center justify-center">

      <Img
        src={mlw}
        alt="Madam Ladies Wear"
        loading="eager"
        objectFit="contain"
        className={`w-full max-w-[420px] h-auto ${className}`}
      />

    </Link>

  )

}